export class Resource {
    constructor(tag, slug) {
        this.tag = tag;
        this.slug = slug;
        this.endpoints = [];
        this.entity = null;
    }
    get title() {
        return this.tag.name;
    }
    get summary() {
        return this.tag.name;
    }
    get description() {
        return this.tag.description;
    }
}
